import React, { useCallback } from 'react';
import { useFlatInfoClick } from '../lib/flatHandlers';
import { useModalActions } from '../providers/modals';

export const withAddAndInfo = ({ Component: ExternalComponent }) => {
  const Component = ({ room, stopPropagation = false, ...props }) => {
    const onInfoClick = useFlatInfoClick();
    const { openAddAccountOrTenantModal } = useModalActions();

    const addressId = room.addressId;

    const handleInfoBtnClick = useCallback(
      (e) => {
        stopPropagation && e.stopPropagation();
        onInfoClick(addressId);
      },
      [onInfoClick, addressId, stopPropagation]
    );

    const handleMenuClick = useCallback(
      (key) => {
        openAddAccountOrTenantModal(key, room);
      },
      [openAddAccountOrTenantModal, room]
    );

    return (
      <ExternalComponent
        {...props}
        onInfoBtnClick={handleInfoBtnClick}
        onMenuClick={handleMenuClick}
      />
    );
  };

  return Component;
};
